import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ToastrService } from 'ngx-toastr';
import { Overtime, OvertimeRejectRequest } from 'src/app/_model/overtime';
import { WfApproveRequest } from 'src/app/_model/request/WfApproveRequest';
import { User } from 'src/app/_model/user';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { LookupService } from 'src/app/_services/lookup.service';
import { OvertimeService } from 'src/app/_services/overtime.service';

@Component({
  selector: 'app-overtime-reject-selected',
  templateUrl: './overtime-reject-selected.component.html',
  styleUrls: ['./overtime-reject-selected.component.sass'],
        standalone: true,
        imports : [
            MatDialogModule,
            MatSelect
        ]
})
export class OvertimeRejectSelectedComponent implements OnInit {

  selectedRejectReason: any = {};
  rejectDescription = '';
  rejectReasons: any[];
  request: OvertimeRejectRequest = new OvertimeRejectRequest();
  currentUser: User;
  constructor(public dialogRef: MatDialogRef<OvertimeRejectSelectedComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Overtime[],
    private authService: AuthenticationService,
    private overtimeService: OvertimeService,
    private toastr: ToastrService,
    private lookupService: LookupService) {
    this.currentUser = this.authService.currentUserValue;
  }

  ngOnInit() {
    this.rejectReasons = this.lookupService.localOvertimeRejectReasonLookupList();
  }
  rejectSelected() {

    this.data.forEach(element => {
      this.request.employeeId = this.currentUser.employeeId;
      this.request.operationRecordId = element.id;
      this.request.operationTableName = "OVERTIME";
      this.request.rejectDescription = this.rejectDescription;
      this.request.rejectReasonId = this.selectedRejectReason.id;
      this.overtimeService.rejectOvertime(this.request).subscribe(result => {
        this.toastr.success('Reddetme işlemi başarılı', '');
        this.dialogRef.close();
      }, error => {
        this.toastr.error(error.error.msg, 'Hata');
        this.dialogRef.close();
      });
    });

  }

}
